import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';


@Injectable({
  providedIn: 'root'
})
export class BlogSectionService {

  constructor(private http: HttpClient) { }

  url = environment.serverAPI4 + "/api/ig/blog";


  getBlogPage(Page: number, size: number, sort: any): Observable<Object> {
    return this.http.get(`${this.url}?page=${Page}&size=${size}&sort=${sort}`);
  }

}
